import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { TransferOwnershipStates } from './transfer-ownership-states';
import { FiTransferOwnershipComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership/fi-transfer-ownership.component';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatCard, MatCardModule } from '@angular/material/card';
import { RequestAccessSettingModule } from '@fi-app/request-access-setting/request-access-setting.module';
import { ButtonBackModule } from '@fi-app/utilities/button-back/button-back.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiTransferOwnershipIntroductionCardComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-introduction-card/fi-transfer-ownership-introduction-card.component';
import { FiTransferOwnershipService } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership.service';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiTransferOwnershipFromCardComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-from-card/fi-transfer-ownership-from-card.component';
import { FiTransferOwnershipToCardComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-to-card/fi-transfer-ownership-to-card.component';
import { FiTransferOwnershipHelperService } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-helper.service';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiTransferOwnershipSelectContentCardComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-select-content-card/fi-transfer-ownership-select-content-card.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiTransferOwnershipSummaryCardComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-summary-card/fi-transfer-ownership-summary-card.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiTransferOwnershipConfirmDialogComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-confirm-dialog/fi-transfer-ownership-confirm-dialog.component';
import { FiTransferOwnershipSummaryDataComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-summary-data/fi-transfer-ownership-summary-data.component';
import { FiTransferOwnershipCompletedCardComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-complited-card/fi-transfer-ownership-completed-card.component';
import { MatIconModule } from '@angular/material/icon';
import { FiTransferOwnershipUserSelectComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership-user-select/fi-transfer-ownership-user-select.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UIRouterModule.forChild(TransferOwnershipStates),
        FiPageHeaderModule,
        MatCardModule,
        MatCheckboxModule,
        RequestAccessSettingModule,
        ButtonBackModule,
        FiAppTextSharedModule,
        FiLoadingModule,
        SelectSearchModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        FiProfileIconModule,
        MatIconModule,
    ],
    declarations: [
        FiTransferOwnershipComponent,
        FiTransferOwnershipIntroductionCardComponent,
        FiTransferOwnershipFromCardComponent,
        FiTransferOwnershipToCardComponent,
        FiTransferOwnershipSelectContentCardComponent,
        FiTransferOwnershipSummaryCardComponent,
        FiTransferOwnershipConfirmDialogComponent,
        FiTransferOwnershipSummaryDataComponent,
        FiTransferOwnershipCompletedCardComponent,
        FiTransferOwnershipUserSelectComponent,
    ],
    providers: [FiTransferOwnershipService, FiTransferOwnershipHelperService],
})
export class TransferOwnershipModule {}
